module.exports = __webpack_public_path__ + "img/lightbulb.b2bfe15f.svg";